export class ProfileBenefit {
  public Id: number;
  public ProfileId: number;
  public BenefitTypeId: number;
  public Quantity: number;
  public QuantityUsed: number;
  public Value: number;
  public ValueUsed: number;
  public ExpirationDate: Date;
  public Active: boolean;
  public DateInactivated: Date;
  public EventBenefit: boolean;
  public Benefit: string;
  public ReportName: string;
  public RenewAnnually: boolean;
  public QuantityRemaining: number;
  public ValueRemaining: number;

  public constructor() {
    this.Id = 0;
    this.ProfileId = 0;
    this.BenefitTypeId = 0;
    this.Quantity = 0;
    this.QuantityUsed = 0;
    this.Value = 0;
    this.ValueUsed = 0;
    this.ExpirationDate = new Date();
    this.Active = false;
    this.DateInactivated = new Date();
    this.EventBenefit = false;

    this.Benefit = '';
    this.ReportName = '';
    this.RenewAnnually = false;

    this.QuantityRemaining = 0;
    this.ValueRemaining = 0;
  }
}
